export const USERS__SUBMIT_LICENSE = 'USERS__SUBMIT_LICENSE';
export const USERS__UPDATE_LICENSE = 'USERS__UPDATE_LICENSE';
